import { btnAddToCart } from "./cart";
// import { initOptionsToggle } from "./jolly-option-toggle";

// initOptionsToggle();

document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
document.body.scrollTop = 0; // For Safari

// WORKING URL example: 
// https://anatae.fr/pages/diagnostic?profils=%5B_____,test,test2,premium,hojicha,genmaicha,classique,_____%5D&results=%5B1:Pour%20vous,2:_____,3:_____,4:Avoir%20un%20effet%20anti-inflammatoire%2C%20Renforcer%20mon%20immunit%C3%A9%2C%20Am%C3%A9liorer%20mon%20bien-%C3%AAtre%20global,5:Je%20suis%20curieux,6:Le%20matin%20au%20petit-d%C3%A9jeuner,7:Les%20deux%5D#accessoires
//
 
/**
 * Parses quizz results from the URL query string, extracting 'profiles' and 'results' parameters.
 * @returns {{profiles: string[], results: string[]}} An object containing arrays of profile and result values.
 */
function getQuizzResultFromURL() {
  // Get the query string from the current URL
  const queryString = window.location.search;

  // Store the raw query string in localStorage
  localStorage.setItem("quizzUrlResult", queryString);

  // Initialize the return object
  const parsedResult = {
    profiles: [],
    results: [],
  };

  // If there's no query string, return the empty object
  if (!queryString) return parsedResult;

  // Create a URLSearchParams object for easy parsing
  const searchParams = new URLSearchParams(queryString);

  // Extract 'profiles' parameter
  const profilesParam = searchParams.get("profils");
  if (profilesParam) {
    parsedResult.profiles = profilesParam.split(",");
  }

  // Extract 'results' parameter
  const resultsParam = searchParams.get("results");
  if (resultsParam) {
    parsedResult.results = resultsParam.split(",");
    const resultsArray = resultsParam ? resultsParam.replace(/[\[\]_____]/g, '').split(',').filter(Boolean) : [];

    let formattedResults = resultsArray
      .map(item => {
        const [key, value] = item.split(':');
        return { key: key.trim(), value: decodeURIComponent(value).trim() };
      })
      .filter(entry => entry.value);

    let resultHTML = "";
    formattedResults.forEach(entry => {
      resultHTML += `${entry.value},`;
    });
    // Display the results in div#results
    document.querySelector(".jc-quiz-results-list").dataset.results = resultHTML;
  }

  return parsedResult;
}

async function fetchQuizzSection(sectionId, data) {
  return new Promise(function (resolve, reject) {
    let qq, query;
    if (typeof data != "number") {
      query = data.profiles
        .join("_");
      qq = "&q=" + query;
    } else {
      qq = "&q=id:" + data;
    }
    const url = "/search/?sections=" + sectionId + qq + data.results;

    fetch(url).then(function (r) {
      r.json().then(function (res) {
        var keys = Object.keys(res);
        if (keys.length > 0) {
          return resolve(res[keys[0]]);
        }
        return reject();
      });
    });
  });
}

async function initQuizz() {
  // show preloader
  let quizzPreloader = document.querySelector("quizz-preloader")
  
  if (quizzPreloader) {
    quizzPreloader.classList.remove('!jc-hidden');
  }

  // parse query Parameters
  const quizzResults = getQuizzResultFromURL();

  // fetch section and replace HTML
  const parser = new DOMParser();
  const quizSection = window.quiz_results_section;
  const quizzContentResponse = await fetchQuizzSection(quizSection, quizzResults);
  let quizzHTML = parser.parseFromString(
    quizzContentResponse,
    "text/html"
  );

  const quizzSection = document.querySelector("quizz-content");

  if (!quizzSection) return;

  quizzSection.innerHTML = quizzHTML.querySelector("quizz-content").innerHTML

  // hide preloader
  if (quizzPreloader) {
    setTimeout(()=> {
      quizzPreloader.classList.add('!jc-hidden');
    }, 4000)
  }

  btnAddToCart('.add-product-cart');
  document.dispatchEvent(new CustomEvent('update-diagnostic-cart'))
}

window.addEventListener("DOMContentLoaded", async () => {
  initQuizz();
  if (window.location.pathname.indexOf("/quizz-result") != -1) {
  }
});

class QuizzPreloader extends HTMLElement {
  constructor() {
    super();
  }

  show() {
    this.classList.add("active");
  }

  hide() {
    this.classList.remove("active");
  }
}

customElements.define("quizz-preloader", QuizzPreloader);


class QuizzProductCard extends HTMLElement {
  constructor() {
    super();
    this.addTocart = this.querySelector('.quiz-add-to-cart');
    this.options = this.querySelectorAll('.jc-diagnostic-variant-option');
    this.price = this.querySelector('.product-card__form-price');
  }

  connectedCallback() {
 

    this.options.forEach((option, index) => {



      option.addEventListener('click', () => {
        let selectedVariant = option.getAttribute('data-variant');
        this.querySelector('[name="id"]').value = selectedVariant;

        this.options.forEach(option => {
          option.classList.remove('active')
        }); 

        const productImages = this.querySelectorAll('[class^="productcard_image-"]');
        productImages.forEach((image) => {
          image.classList.add('jc-opacity-0');
        })
 
        let productCard = option.closest('.js-product-card');
        let imageElement = productCard.querySelector('.productcard_image-' + index);

        if (!imageElement) {
          imageElement = productCard.querySelector('.productcard_image-0');
        }

        if (imageElement) {
          imageElement.classList.remove('jc-opacity-0');
        }

        this.price.textContent = option.dataset.price;

        option.classList.add('active');
      });
    })
  }
}

customElements.define("quizz-product-card", QuizzProductCard);


class QuizResults extends HTMLElement {
  constructor() {
    super();
    this.toggleResults = this.querySelector('.jc-quiz-results-toggle');
    this.expanded = this.getAttribute('data-expanded') === 'true';
    this.list = this.querySelector('ul');
  }

  connectedCallback() {
    this.toggleResults.addEventListener('click', () => {
      this.expanded = !this.expanded;
      this.setAttribute('data-expanded', this.expanded);
    });
  }
}

customElements.define("quiz-results", QuizResults);

class DiagnosticCart extends HTMLElement {
  constructor() {
    super();
    this.checkoutBtn = this.querySelector('#jc-quiz-checkout');
    this.expanded = this.getAttribute('data-expanded') === 'true';
    this.list = this.querySelector('ul');
  }

  connectedCallback() {
    this.checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = '/checkout';
    });
  }
}

customElements.define("diagnostic-cart", DiagnosticCart);


class PageNav extends HTMLElement {
  static observedAttributes = ['data-loaded'];

  constructor() {
    super();
    this.navList = this.querySelector("[data-page-nav-list]");
    this.template = this.querySelector("#page-nav-el-tmp");
    this.navSections = document.querySelectorAll("[data-nav-url]");
    this.topGap = this.getAttribute("data-top-gap") || 0;
    this.activeLink = null;
    this.disableLinkScroll = false;

  }

  connectedCallback() {
    this.initNavLinks();
    // this.initObserver();
  }

  initNavLinks() { 
    this.navSections.forEach((section) => {
      const newLi = this.template.innerHTML
        .replace("{section}", section.dataset.navUrl)
        .replace("{title}", section.dataset.navTitle);
      this.navList.insertAdjacentHTML("beforeend", newLi);
    });

    this.navLinks = this.querySelectorAll("[data-scroll-section]");

    this.navLinks[0].classList.add('active')

    this.navLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const diagnosticWrap = document.querySelector('.jc-diagnostic-wrap');

        let sectionToScroll = document.querySelector(`[data-nav-url="${link.dataset.scrollSection}"]`);
        let pageOffsetTop =  diagnosticWrap.offsetTop;
        let pageOffset =  diagnosticWrap.offsetTop + diagnosticWrap.scrollHeight;

        if (sectionToScroll) {

          if (pageOffset <= sectionToScroll.offsetTop) {
            pageOffsetTop = 0;
          }

          let sectionOffsetTop = sectionToScroll.offsetTop + pageOffsetTop;

          scrollTo(0, Math.max(sectionOffsetTop - this.topGap, 0));

          this.disableLinkScroll = true;
          this.navLinks.forEach((link) => link.classList.remove("active"));
          link.classList.add("active");
          setTimeout(() => (this.disableLinkScroll = false), 500);
          this.scrollToLink(link);
        }
      });
    });
  }

  // initObserver() {
  //   this.naviObserver = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (
  //           entry.isIntersecting &&
  //           window.scrollY >= entry.intersectionRect.y &&
  //           entry.intersectionRatio > 0.7
  //         ) {
  //           const currentActiveLink = this.querySelector(`[data-scroll-section="${entry.target.getAttribute("data-nav-url")}"]`);

  //           if (!this.disableLinkScroll) {
  //             this.navLinks.forEach((link) => link.classList.remove("active"));
  //             currentActiveLink.classList.add("active");

  //             if (currentActiveLink != this.activeLink)
  //               this.scrollToLink(currentActiveLink);
  //             this.activeLink = currentActiveLink;
  //           }
  //         }
  //       });
  //     },
  //     {
  //       root: null,
  //       rootMargin: "0px",
  //       threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
  //     }
  //   );

  //   this.navSections.forEach((section) => {
  //     this.naviObserver.observe(section);
  //   });
  // }

  scrollToLink(link) {
    let scrollX;
    if (link.getBoundingClientRect().x > this.scrollLeft) {
      scrollX = this.scrollLeft + link.getBoundingClientRect().x + 12;
    } else {
      scrollX = this.scrollLeft + link.getBoundingClientRect().x - 12;
    }

    document
      .querySelector("page-nav")
      .scroll({ left: scrollX, behavior: "smooth" });
  }
}

customElements.define("page-nav", PageNav);



document.addEventListener('update-diagnostic-cart', () => {
  let all_products = [];

  document.querySelectorAll('quizz-product-card [name="variants"]').forEach(variants => {
    let array = JSON.parse(variants.value);
    const variantIds = array.map(variant => variant.id);
    if (variantIds) {
      all_products.push(variantIds)
    }
  })

  const simplifiedArray = [...new Set(all_products.flat())];
  const simplifiedArrayStr = simplifiedArray.map(String);

  window.visibleItems = 0;
  window.cartItems = document.querySelectorAll('diagnostic-cart .js-cart-item');

  cartItems.forEach(item => {
    let itemId = item.dataset.id
    if (simplifiedArrayStr.includes(itemId)) {
      item.setAttribute('data-hidden', false);

      window.visibleItems += 1;
    }
  });
});